<mat-drawer mode="side" opened class="sidebar open" [ngClass]="{'close': showhide}">

    <ng-scrollbar #scrollable trackY="false" trackX="true" track="all" pointerEventsMethod="scrollbar">
        <div class="w-100 side-nav-block">
            <!--Top-->
            <div class="menu-collapse-area logo-arrow-wrap" [ngClass]="{'open': showhide}">
                <div class="main-logo-image">
                    <img src="assets/images/logo-white.svg" alt="Boomcaster">
                </div>

                <div class="main-mobile-logo-image">
                    <img src="/assets/images/Logo-B.svg" alt="Boomcaster" width="25" height="25">
                </div>

                <div class="back-arrow" (click)="menutoggle()">
                    <img src="assets/images/menu-left.svg" />
                </div>
                <div class="menu-lines" (click)="menutoggle()">
                    <img src="assets/images/menu-right.svg" />
                </div>
            </div>
            <!--top-end-->

            <!--mid-->
            <div class="user-menu-wrap">
                <div class="user-image">
                    <img src="assets/images/user-img.svg" alt="">
                </div>
                <div class="top-details">
                    <p class="user-name text-center" *ngIf="!showhide">
                        {{ userInfo?.fullName }}
                    </p>
                    <p class="user-name text-center" *ngIf="showhide">
                        {{ (userInfo?.fullName | formatName : 'firstLastName1Char') | uppercase }}
                    </p>

                </div>

                <!-- <div class="plan-details">
                  <div class="row">
                      <div class="col s6">
                          <div class="storage w-100">
                              <canvas baseChart [data]="pieChartData" [colors]="pieChartColors" [chartType]="pieChartType"
                                  [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend"
                                  [labels]="pieChartLabels"
                                  id="chart-area" width="200" height="200">
                              </canvas>
                              <p class="text-center">Storage</p>
                          </div>
                      </div>
                      <div class="col s6">
                          <div class="time w-100">
                              <canvas baseChart [data]="pieChartData2" [colors]="pieChartColors"
                                  [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins"
                                  [labels]="pieChartLabels2"
                                  [legend]="pieChartLegend" id="chart-areas" width="200" height="200">
                              </canvas>
                              <p class="text-center">Time</p>
                          </div>
                      </div>
                  </div>
                  <div class="text-center">
                      <button mat-flat-button class="button button-small filled" (click)="upgradestorage()">Upgrade
                          storage</button>
                  </div>
              </div> -->
                <div class="navigation-links">
                    <mat-list>
                        <mat-list-item data-step="25" data-title="Sessions" data-intro="Collection of all the sessions"
                            aria-label="Button that displays a tooltip when focused or hovered over" class="tooltip">
                            <a matLine [routerLink]="['/users/dashboard']" routerLinkActive="active">
                                <span class="material-icons side-menu-icon">
                                    dashboard
                                </span> <span class="menu-text">Dashboard</span>
                            </a>
                            <span class="tooltiptext" *ngIf="showhide">Dashboard</span>
                        </mat-list-item>

                        <mat-list-item data-step="26" data-title="Customize Studio" data-intro="Customize Studio with Brand Logo and Color Palette"
                            class="tooltip">
                            <a matLine [routerLink]="['/users/configuration']" routerLinkActive="active">
                                <span class="material-icons  side-menu-icon">
                                    wifi_tethering
                                </span> <span class="menu-text">Configuration</span>
                            </a>
                            <span class="tooltiptext" *ngIf="showhide">Configuration</span>
                        </mat-list-item>

                        <mat-list-item data-step="27" class="tooltip" data-title="Manage Account Settings"
                            data-intro="Manage Subscription and Account Settings" class="tooltip">
                            <a matLine [routerLink]="['/users/account-setting']" routerLinkActive="active">
                                <span class="material-icons  side-menu-icon">
                                    settings
                                </span> <span class="menu-text">Account</span>
                            </a>
                            <span class="tooltiptext" *ngIf="showhide">Account</span>
                        </mat-list-item>

                        <mat-list-item data-step="28" data-title="Manage Referrals" data-intro="Invite friends to get rewarded" class="tooltip">
                            <a matLine [routerLink]="['/users/referrals']" routerLinkActive="active" href="#">
                                <span class="material-icons">
                                    local_offer
                                </span> <span class="menu-text">Referrals</span>
                            </a>
                            <span class="tooltiptext" *ngIf="showhide">Referrals</span>
                        </mat-list-item>

                        <mat-list-item class="tooltip">
                            <a matLine href="https://support.Boomcaster.com" target="_blank">
                                <span class="material-icons  side-menu-icon">
                                    help
                                </span> <span class="menu-text">Get Help</span>
                            </a>
                            <span class="tooltiptext" *ngIf="showhide">Get Help</span>
                        </mat-list-item>

                        <mat-list-item class="logout-mobile tooltip">
                            <a matLine href="javascript:void(0)" (click)="logout()">
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="22.595" height="18.445" viewBox="0 0 22.595 18.445">
                  <defs>
                    <style>
                      .a {
                        fill: #fff;
                      }
                    </style>
                  </defs>
                  <g transform="translate(0 -41.115)">
                    <g transform="translate(0 41.115)">
                      <path class="a"
                        d="M9.223,58.177a.375.375,0,0,1-.029-.195c.01-.052-.024-.1-.1-.13s-.115-.06-.115-.079-.055-.034-.166-.043l-.166-.015H4.15a2.219,2.219,0,0,1-1.628-.677,2.22,2.22,0,0,1-.677-1.628V45.265a2.22,2.22,0,0,1,.677-1.628,2.22,2.22,0,0,1,1.628-.677H8.761a.435.435,0,0,0,.3-.094.479.479,0,0,0,.144-.281,2.425,2.425,0,0,0,.043-.339,3.585,3.585,0,0,0-.007-.382q-.014-.23-.014-.288a.467.467,0,0,0-.461-.461H4.15a4,4,0,0,0-2.933,1.218A4,4,0,0,0,0,45.265V55.41a4,4,0,0,0,1.218,2.932A4,4,0,0,0,4.15,59.56H8.762a.437.437,0,0,0,.3-.094.479.479,0,0,0,.144-.281,2.429,2.429,0,0,0,.043-.339,3.582,3.582,0,0,0-.007-.382Q9.222,58.234,9.223,58.177Z"
                        transform="translate(0 -41.115)" />
                      <path class="a"
                        d="M126.421,58.359l-7.839-7.839a.922.922,0,0,0-1.571.649v4.15h-6.456a.935.935,0,0,0-.922.922v5.534a.935.935,0,0,0,.922.922h6.456v4.15a.917.917,0,0,0,1.571.648l7.839-7.839a.905.905,0,0,0,0-1.3Z"
                        transform="translate(-104.1 -49.785)" />
                    </g>
                  </g>
                </svg>  -->
                                <span class="material-icons  side-menu-icon">
                                    logout
                                </span>
                                <span class="menu-text">Log Out</span>
                            </a>
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
            <!--midend-->

            <!--bottom-->
            <div class="logout-icon-bottom">
                <mat-list class="log-out ">
                    <mat-list-item>
                        <a matLine href="javascript:void(0)" (click)="logout()">
                            <span class="material-icons  side-menu-icon">
                                logout
                            </span> <span class="menu-text">Logout</span>
                        </a>
                    </mat-list-item>
                </mat-list>
            </div>
            <!--bottom end-->

        </div>

    </ng-scrollbar>

</mat-drawer>